import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

import * as filters from '@/filters'
import PlusScan from '@/components/PlusScan'
import MuiHeader from '@/components/MuiHeader'

Vue.use(MintUI)
Vue.component('MuiHeader', MuiHeader)
Vue.component('PlusScan', PlusScan)

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})



// WEBPACK FOOTER //
// ./src/utils/vue-init.js